export default "__VITE_ASSET__80DTH9Q8__"